import repository from '@/utils/repository';

const resource = '/move/PTJ_Worker022';

export default {
    store: (data) => {
        return repository.post(
            `${resource}/store`,
            {
                ...data
            },
            {
                skipGlobalErrorHandling: true
            }
        );
    }
};
